var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.684 473.684",
    style: {
      enableBackground: "new 0 0 473.684 473.684"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E61E25"
    },
    d: "M315.802,13.535l-27.639,76.632c25.512,84.193,25.512,209.156,0,293.353l27.639,76.624 c91.975-32.523,157.882-120.195,157.882-223.31C473.684,133.735,407.777,46.059,315.802,13.535z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4E4E4"
    },
    d: "M315.802,90.167V13.535C291.102,4.8,264.536,0.002,236.84,0.002 C273.361,0.002,222.723,123.775,315.802,90.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E4E4E4"
    },
    d: "M236.84,473.682c27.695,0,54.262-4.798,78.962-13.534v-76.624 C223.658,374.328,236.84,473.682,236.84,473.682z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#3757A6"
    },
    d: "M0,236.837C0,340.297,66.355,428.2,158.806,460.461V13.229C66.355,45.49,0,133.393,0,236.837z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EF4F4E"
    },
    d: "M315.802,90.167V383.52C341.317,299.323,341.317,174.359,315.802,90.167z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3F4F5"
    },
    d: "M315.802,383.523V90.167C299.677,36.938,273.361,0.002,236.84,0.002 c-27.351,0-53.592,4.697-78.034,13.227v447.234c24.442,8.53,50.683,13.22,78.034,13.22 C273.361,473.682,299.677,436.746,315.802,383.523z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrance);
export default __webpack_public_path__ + "static/media/france.845f1cd42497ca3efe3085d616585eab.svg";
export { ForwardRef as ReactComponent };